<script setup lang="ts">
import { computed } from 'vue'
import Warning from '@/components/Base/Icons/WarningIcon.vue'
import Success from '@/components/Base/Icons/SuccessIcon.vue'
import Info from '@/components/Base/Icons/InfoIcon.vue'
import Error from '@/components/Base/Icons/ErrorIcon.vue'

const props = defineProps<{
  message?: string
  paragraphs?: string[]
  type: 'info' | 'warning' | 'error' | 'success' | 'neutral'
  innerHtml?: boolean
}>()

const typeClasses = computed(() => {
  switch (props.type) {
    case 'info':
      return 'bg-primary-50 text-primary-800 border-primary-700'
    case 'warning':
      return 'bg-warning-50 text-warning-800 border-warning-700'
    case 'error':
      return 'bg-danger-50 text-danger-800 border-danger-700'
    case 'success':
      return 'bg-success-50 text-success-800 border-success-400'
  }

  return 'bg-neutral-50 text-neutral-800 border-neutral-400'
})

const iconClasses = computed(() => {
  switch (props.type) {
    case 'info':
      return 'text-primary-700'
    case 'warning':
      return 'text-warning-700'
    case 'error':
      return 'text-danger-700'
    case 'success':
      return 'text-success-400'
  }

  return 'text-neutral-400'
})

const hasParagraphs = computed(() => props.paragraphs?.length)

const iconType = computed(() => {
  const iconType = {
    info: Info,
    warning: Warning,
    error: Error,
    success: Success,
    neutral: Info,
  }

  return iconType[props.type] ?? ''
})
</script>

<template>
  <div
    class="flex px-4 py-4 mb-1 text-sm flex-col border-l-[6px]"
    :class="typeClasses"
  >
    <div class="flex items-center gap-4">
      <div>
        <component
          :is="iconType"
          class="h-5 w-5 mb-[3px]"
          :class="iconClasses"
        />
      </div>
      <template v-if="hasParagraphs">
        <p v-for="paragraph in paragraphs" :key="paragraph" class="mb-2">
          {{ $t(paragraph) }}
        </p>
      </template>

      <template v-if="innerHtml">
        <p v-html="message"></p>
      </template>

      <template v-else>
        {{ message }}
      </template>
    </div>
  </div>
</template>
